<div class="header">
  <h2>{{ "how-to-play.title" | mnTranslate }}</h2>
  <p>{{ "how-to-play.steps-to-win" | mnTranslate }}</p>
  <mn-button class="close" aEvent="tutorial_close" (clicked)="close()">
    <mn-svg name="close" />
  </mn-button>
</div>

<div class="top-row row">
  <div class="g-8 step-item">
    <div class="step-icon">01</div>
    <div class="f-c g-4">
      <h3 class="step-title">{{ "how-to-play.text-1.title" | mnTranslate }}</h3>
      <p class="step-msg">{{ "how-to-play.text-1.msg" | mnTranslate }}</p>
    </div>
  </div>

  <div class="mock-panel">
    <div class="panel-section">
      <span class="mock-label c-se">{{ "mines.count" | mnTranslate }}</span>
      <div class="mock-mines-count">
        <span class="ctrl">−</span>
        <span class="mock-value t-r c-p">3</span>
        <span class="ctrl">+</span>
      </div>
    </div>
    <div class="panel-section">
      <span class="mock-label c-se">{{ "bet.amount" | mnTranslate }}</span>
      <div class="mock-amount">
        <mn-svg name="minus" class="c-p" />
        <div class="amount t-s-h">{{ prefix }}100</div>
        <mn-svg name="plus" class="c-p" />
      </div>
    </div>
  </div>
</div>

<div class="middle-row row">
  <div class="g-8 step-item">
    <div class="step-icon">02</div>
    <div class="f-c g-4">
      <h3 class="step-title">{{ "how-to-play.text-2.title" | mnTranslate }}</h3>
      <p class="step-msg">{{ "how-to-play.text-2.msg" | mnTranslate }}</p>
    </div>
  </div>
  <div class="play-btn">
    <mn-button size="play" type="play" aEvent="btn_play" [animation]="false">
      <b class="t-s-h u-c c-p-i">{{ "btn.play" | mnTranslate }}</b>
    </mn-button>
  </div>
</div>

<div class="bottom-row row">
  <div class="g-8 step-item">
    <div class="step-icon">03</div>
    <div class="f-c g-4">
      <h3 class="step-title">{{ "how-to-play.text-3.title" | mnTranslate }}</h3>
      <p class="step-msg">{{ "how-to-play.text-3.msg" | mnTranslate }}</p>
    </div>
  </div>
  <div class="collect-preview">
    <div class="mock-collect">
      <span class="t-s-s u-c c-se">{{ "btn.collect" | mnTranslate }}</span>
      <span class="t-s-h c-y">{{ prefix }}550</span>
    </div>
  </div>
</div>

<mn-button class="continue" size="regular" aEvent="tutorial_continue" (clicked)="close()">
  <span class="t-s-h u-c c-b">{{ "btn.continue" | mnTranslate }}</span>
</mn-button>

<div class="checkbox" data-ui-sound mnClickArea mnAnalyticsClick="tutorial_do_not_show" (click)="toggle()">
  <div class="checkbox-content t-r" [class.checked]="show()">{{ "checkbox.do-not-show-again" | mnTranslate }}</div>
</div>
